<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">User Table</h3>
            <button class="btn btn-success" (click)="initModal('create')">Create</button>
          </div>

          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>EMAIL</th>
                  <th class="w-1">ROLE</th>
                  <th class="w-1">Last online</th>
                  <th class="w-1">CREATE</th>
                  <th class="w-1">ACT.</th>
                </tr>
              </thead>
              <tbody *ngIf="!isLoading">
                <tr *ngFor="let user of usersList">
                  <td>
                    <label class="switch" [class.hidden]="currentUser.adminId == user.adminId">
                      <input type="checkbox" [checked]="user.active" #ckb (change)="activeUser(user, ckb)">
                      <span class="slider round"></span>
                    </label>
                  </td>
                  <td>
                    <span>{{ user.email }}</span>
                  </td>
                  <td>
                    <span>{{user.role}}</span>
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ user.lastLoginAt | date:'hh:mm dd-MM-yyyy' }}
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ user.createdAt | date:'hh:mm dd-MM-yyyy' }}
                  </td>
                  <td>
                    <a class="btn btn-default" (click)="initModal('edit', user)">
                      <i class="fa fa-edit" aria-hidden="true"></i>
                    </a>
                    <a *ngIf="currentUser.adminId != user.adminId" class="btn btn-danger" (click)="deleteUser(user)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="usersList?.length === 0">
                  <td class="text-center" colspan="8">
                    <span>Can not found.</span>
                  </td>
                </tr>
                <tr *ngIf="usersList?.length !== 0">
                  <td colspan="8">
                    Displaying {{filterParams.page * filterParams.size + 1}} - {{ (filterParams.page) * filterParams.size + usersList?.length
                    }} of {{ totalElements }}
                    <ul *ngIf="filterParams.size < totalElements" class="pagination pull-right">
                      <li [class.disabled]="filterParams.page == 0" (click)="filterParams.page = filterParams.page - 1">
                        <a>
                          <span aria-hidden="true">«</span>
                          Previous</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 3" (click)="filterParams.page = 0">
                        <a>1</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 4" class="disabled hidden">
                        <a>...</a>
                      </li>
                      <li *ngFor="let number of initPaginate()" [class]="filterParams.page == number ? 'active' : class" [class.hidden]="(filterParams.page + 2 < number || filterParams.page - 2 > number)"
                        (click)="filterParams.page = number">
                        <a>{{ number + 1 }}</a>
                      </li>
                      <li [class.hidden]="filterParams.page > totalPage - 5" class="disabled">
                        <a>...</a>
                      </li>
                      <li [class.hidden]="filterParams.page >  totalPage - 4" (click)="filterParams.page = totalPage -1">
                        <a>{{ totalPage }}</a>
                      </li>
                      <li [class.disabled]="filterParams.page == totalPage - 1" (click)="filterParams.page = filterParams.page + 1">
                        <a>
                          <span aria-hidden="true">»</span>
                          Next</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>


            <p class="text-center" *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>

  </section>
</div>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <form (ngSubmit)="onSubmit(formUser)" #formUser="ngForm">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title"> {{ modal.title }}</h4>
        </div>
        <div class="modal-body">
          <input type="text" style="display:none" name="id" ngModel [(ngModel)]="user.id">
          <div class="form-group">
            <label>Email:</label>
            <input type="email" class="form-control" name="email" [(ngModel)]="user.email" ngModel #txtEmail="ngModel" placeholder="Email"
              required email>
            <span *ngIf="txtEmail.errors?.required  && txtEmail.dirty" class="text text-danger">Email is required.
              <br>
            </span>
            <span *ngIf="txtEmail.errors?.email && txtEmail.dirty" class="text text-danger">Email is invalid.</span>
          </div>
          <div class="form-group">
            <label>Password:</label>
            <input type="password" class="form-control" name="password" [(ngModel)]="user.password" ngModel #txtPassword="ngModel" placeholder="Password"
              [required]="modal.state == 'create'">
            <span *ngIf="txtPassword.errors?.required  && txtPassword.dirty" class="text text-danger">Password is required.
              <br>
            </span>
          </div>
          <div class="form-group" [class.hidden]="currentUser.adminId == user.id">
            <label>
              <input type="radio" name="role" value="ADMIN" [(ngModel)]="user.role" required ngModel> ADMIN</label>
            <label>
              <input type="radio" name="role" value="MANAGER" [(ngModel)]="user.role" required ngModel> MANAGER</label>
          </div>

          <div class="form-group" *ngIf="modal.state == 'edit'" [class.hidden]="currentUser.adminId == user.id">
            <label class="switch">
              <input type="checkbox" name="active" [(ngModel)]="user.active">
              <span class="slider round"></span>
            </label>
          </div>

        </div>
        <div class="modal-footer">
          <button type="submit" [disabled]="formUser.invalid" class="btn btn-primary">{{ modal.btnName }}</button>
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </form>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/users/users.component.html